import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// Enable React DevTools in development
if (import.meta.env.DEV) {
  // React DevTools will be available automatically in development
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)